import { useState } from "react";
import { Outlet, NavLink, useNavigate, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Star, Ticket, FolderTree, Users, Mail, MessageSquare, FileText, Settings, LogOut, Menu, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const NAV = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: "/admin/products", label: "Products", icon: Package },
    { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
    { to: "/admin/reviews", label: "Reviews", icon: Star },
    { to: "/admin/coupons", label: "Coupons", icon: Ticket },
    { to: "/admin/categories", label: "Categories", icon: FolderTree },
    { to: "/admin/customers", label: "Customers", icon: Users },
    { to: "/admin/newsletter", label: "Newsletter", icon: Mail },
    { to: "/admin/enquiries", label: "Enquiries", icon: MessageSquare },
    { to: "/admin/content", label: "Content & CMS", icon: FileText },
    { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
    const { logout, user } = useAuth();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const doLogout = () => { logout(); navigate("/admin/login"); };

    return (
        <div className="min-h-screen bg-gray-50 flex">
            <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-60 bg-ink text-gray-300 flex flex-col transition-transform ${open ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}>
                <div className="p-5 border-b border-white/10 flex items-center justify-between">
                    <Link to="/admin" className="font-serif text-xl tracking-[0.2em] text-white">ELVOSH</Link>
                    <button className="lg:hidden text-white" onClick={() => setOpen(false)}><X className="h-5 w-5" /></button>
                </div>
                <nav className="flex-1 overflow-y-auto py-4 px-3 space-y-1">
                    {NAV.map((n) => (
                        <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)} data-testid={`admin-nav-${n.label.toLowerCase().replace(/ & | /g, "-")}`}
                            className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 rounded text-sm transition-colors ${isActive ? "bg-gold text-white" : "hover:bg-white/10"}`}>
                            <n.icon className="h-4 w-4" /> {n.label}
                        </NavLink>
                    ))}
                </nav>
                <div className="p-3 border-t border-white/10">
                    <button data-testid="admin-logout" onClick={doLogout} className="flex items-center gap-3 px-3 py-2.5 rounded text-sm hover:bg-white/10 w-full"><LogOut className="h-4 w-4" /> Logout</button>
                </div>
            </aside>

            {open && <div className="fixed inset-0 bg-black/40 z-30 lg:hidden" onClick={() => setOpen(false)} />}

            <div className="flex-1 flex flex-col min-w-0">
                <header className="bg-white border-b border-gray-200 h-14 flex items-center px-5 gap-4">
                    <button className="lg:hidden" onClick={() => setOpen(true)}><Menu className="h-5 w-5" /></button>
                    <span className="text-sm text-gray-500 ml-auto">{user?.email}</span>
                    <Link to="/" className="text-sm text-gold hover:underline">View Store →</Link>
                </header>
                <main className="flex-1 p-5 md:p-8 overflow-x-hidden">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
